export var AxisMode;
(function (AxisMode) {
    AxisMode["Linear"] = "Linear";
    AxisMode["Date"] = "Date";
    AxisMode["Logarithmic"] = "Logarithmic";
})(AxisMode || (AxisMode = {}));
export var AxisType;
(function (AxisType) {
    AxisType["x"] = "x";
    AxisType["y"] = "y";
    AxisType["z"] = "z";
    AxisType["y2"] = "y2";
})(AxisType || (AxisType = {}));
//# sourceMappingURL=axis.js.map